<template>
  <div class="item-preview">
    <transition name="fadeLeft">
      <div v-if="!!item.flag" class="item-flag">
        <img :src="item.flag" alt="" />
      </div>
    </transition>

    <!-- Add to list -->
    <!-- state.collections.activeCollectionItems -->
    <div   
        :class="['add-to-col',collections.activeCollectionItems.includes(item.productId) ? 'added' : '']" @click.prevent="addToCollection()" 
        :title="collections.activeCollectionItems.includes(item.productId) ? 'Product in list' : localize('Add to list')">
        <i :class="['fal',collections.activeCollectionItems.includes(item.productId) ? 'fa-plus' : 'fa-plus']"></i>
        <!--<i :class="['fal',collections.activeCollectionItems.includes(item.productId) ? 'fa-list-ul' : 'fa-list-ul']"></i>-->
    </div>

    <!-- <div v-if="isItemConcave" class="concave">{{getFilterLabel('Concave')}}</div> -->

    <!-- todo: change to route-link -->
    <div
      class="item-preview-image"
      :class="['item-' + size, !!showActionsOnDevices ? 'active' : '']"
      :style="previewImageStyle"
      @touchend.passive="toggleActionsForDevices($event)"
      @touchmove.passive="toggleActionsForDevices($event)"
    >

      <transition name="fadeLeft">
        <!-- <template v-if="item.platform && item.platform.length > 1">
          <div
            v-for="platform in item.platform"
            :key="platform"
            :class="['item-platform', parsePlatform(platform)]"
          >
            <span v-text="parsePlatform(platform, true)"></span>
          </div>
        </template>
        <div
          v-else-if="item.platform && typeof item.platform === 'string'"
          :class="['item-platform', parsePlatform(item.platform)]">
          <span v-text="parsePlatform(item.platform, true)"></span>
        </div> -->

        <template v-if="item.platform">
          <div
            v-if="typeof item.platform === 'string'"
            :class="['item-platform', parsePlatform(item.platform_eng)]"
          >
            <span
              class="font-rg"
              v-text="parsePlatform(item.platform_eng, true)"
            ></span>
          </div>
          <div v-else class="item-platform--group">
            <div
              v-for="platform in item.platform_eng"
              :key="platform"
              :class="['item-platform', parsePlatform(platform)]">
              <span class="font-rg" v-text="parsePlatform(platform, true)"></span>
            </div>
          </div>
        </template>
      </transition>
      <div class="item-info" v-if="!!info">
        <div class="info" v-text="item.amount + (item.amount < 2 ? ' item' : ' items')"></div>
      </div>

      <!--<i class="media-icon fal fa-plus"></i>-->
      <!--<i class="media-icon fal fa-ellipsis-h"></i>-->
      <span class="media-icon">{{localize('More info')}}</span>
    </div>
    
    <slot name="label"></slot>
  </div>
</template>
<script>
// import $ from "jquery";
 import { mapState, mapActions } from "vuex";
// import { translate } from "@/utils";

export default {
  props: ["type", "info", "item", "size", "actions", "draggable"],
  created() {},
  data() {
    return {
      addingToList:false,
      addingFav: false,
      hasBeenFaved: false,
      removingFav: false,
      favTransform: false,
      showActionsOnDevices: false,
      btnClickDisabler: false,
      inSwipeScroll: false
      // translate
    };
  },
  methods: {
    ...mapActions(["setItemToCollect","updateStoreCollection","addItemToCollection","showCollectionsViewer"]),
    getFilterLabel(name)
    {
      //let title = 
      //let titleElement = _.filter(this.filtersHash,attr => attr.name === item.ProductId && attr[0] === 44);
      return 'Concave';
      //filtersHash
    },
    addToCollection()
    {      
      var vm=this;
      if(!vm.collections.activeCollectionItems.includes(vm.item.productId))
      {
          var ProductID = vm.item.productId;
          vm.addItemToCollection(ProductID);
      }
    },
    postToApi(apiURL)
    {
      var vm=this;
      vm.addingToList=true;
      fetch(apiURL, {
        method: "POST",
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {"Content-Type": "application/json;charset=UTF-8",'Access-Control-Allow-Origin': '*'},
        referrerPolicy: "no-referrer", // no-referrer, *client
        body: ""
      })
      .then(function(response) {            
          return response.json();//console.log("FIRST THEN RESPONSE  < ", response);
      })
      .then(
          async function(json) 
          {
            vm.addingToList=false;
            if (json.status && json.status && json.status === "error") 
            {
              console.log("[fetch|error] register user >> ", json);
              throw new Error(json.message);
            } else {
              //alert("added");
              vm.updateStoreCollection();
            }
          },
          error => {
            vm.addingToList=false;
            console.log("[fetch|error] register user >> ", error);
            throw new Error(error);
          }
        );          
    },    

    toggleActionsForDevices(e) {
      if (e.type === "touchmove") {
        this.$set(this, "inSwipeScroll", true);
      } else {
        if (!this.inSwipeScroll) {
          if (this.isTouchDevice) {
            setTimeout(
              function() {
                this.showActionsOnDevices = !this.showActionsOnDevices;
              }.bind(this),
              100
            );
          }
        }
        this.$set(this, "inSwipeScroll", false);
      }
    },
    updateItem(e, item) {
      if (!!e.key && /esc/gi.test(e.key)) {
        this.$refs.quant.innerText = item.amount;
        this.$refs.quant.blur();
      } else if (item.amount != this.$refs.quant.innerText) {
        let _item = _.clone(item);
        _item.amount = parseInt(this.$refs.quant.innerText);
        this.$refs.quant.innerText = _.trim(this.$refs.quant.innerText);
        e.target.blur();
      }
    },
    parsePlatform(platform, label) {
      // console.log("parseplatform >> ", platform, " :: ", label);
      if (platform.indexOf("Standard") > -1) {
        return label ? "SP" : "item-platform--sp";
      } else if (platform.indexOf("Wide") > -1) {
        return label ? "WP" : "item-platform--wp";
      } else if (platform.indexOf("Narrow") > -1) {
        return label ? "NP" : "item-platform--np";
      }
    },
    labelFor(action) {
      switch (action) {
        case "open":
        case "view":
          // console.log("view touched");
          return "VIEW ITEM";
        case "plus":
          return "Add to Cart";
        case "images":
          return "Go to Images";
        default:
          return "";
      }
    }
  },
  asyncComputed: {
    previewImageStyle() {
      let vm = this;
      return new Promise(resolve => {
        let img = document.createElement("img");
        img.addEventListener("load", function() {
          resolve(`background-image:url(${vm.item.thumb || vm.item.image})`);
        });
        img.addEventListener("error", function() {
          resolve(
            // "background-image:url(" +
            //   vm.defaultItemBg +
            //   "); background-size: 50%"
            "background:black"
          );
        });

        // $(img).on("load", (err, res) => {
        //   resolve(`background-image:url(${vm.item.image})`);
        // });
        // $(img).on("error", err => {
        //   resolve(
        //     // "background-image:url(" +
        //     //   vm.defaultItemBg +
        //     //   "); background-size: 50%"
        //     "background:black"
        //   );
        // });
        img.src = vm.item.image;
      });
    }
  },
  computed: {
    ...mapState(["collections", "auid","filtersHash"]),
    // ...mapState(["defaultItemBg"]),
    isItemConcave()
    {
      if(this.item.emg_profile_id && this.item.emg_profile_id == 201)
      {
        //return  is emergence profile is concave
        return true;
      }      
      return false;
    },
    isTouchDevice() {
      return true;
    },
    isIOSDevice() {
      return /iPad|iPhone|iPod/.test(window.navigator.platform);
    }
  }
};
</script>

<style scoped>
  .item-preview:hover .add-to-col
  {
    opacity: 1;      
  }
  .added
  {    
    color:#31a9f6 !important;
    background-color: transparent !important;
  }
  .added:hover
  {
    color:#fff;font-weight: 600 !important;
  }
</style>

<style lang="stylus" scoped>
  .concave
    position absolute
    left 49px
    top 21px
    font-size 11px
    color #202020
    z-index 10
  .add-to-col
    opacity 1
    cursor pointer !important
    background-color none
    color #aaa
    position absolute
    right 12px
    top 12px
    text-align center 
    border-radius 15px
    z-index 11
    display table-cell
    vertical-align middle
    width 30px
    height 30px    
    &:hover
      background-color #31a9f6
      color #fff
    i
      cursor pointer !important 
      line-height 30px
      font-size: 15px
      font-weight 500


.flyin
    opacity 1 !important
    /.no-touch &
        box-shadow inset 0px 0px 20px rgba(255,255,255,0.9) !important
 ::selection
    background rgba(gray, 0.2)
    color darken(gray, 30)
.item-preview
    position relative
.item-flag, .item-platform
    position absolute 0 false false 0
    overflow hidden
    z-index 9
    /.no-touch &
        box-shadow 3px 3px 7px rgba(#000, 0.2), inset 2px 2px 10px rgba(#000, 0.5)
    img
        min-width 100%
        max-height 100%
    /.big-item &
        opacity 0.96
    /.no-touch:not(.ie) & > img
        max-width 200%
        min-height 105%
    &.item-platform
        top 0
        transform translate(45%, 45%)
        left 0
        width 30px
        height @width
        border-radius unit(@width/2, 'px')
        border 2px solid transparent
        backface-visibility hidden
        background #fff
        // +below(550px)
        //     right 10px
        //     transform translate(10%, 30%)
        //     width 30px
        //     height @width
        //     border-radius unit(@width/2, 'px')
        span
            center()
            font-size responsive 12px 13px
            font-range 1366px 1920px
            font-weight 400
            color darkgray
            span
              color gray_8
        &--np
            border-color #ffd200
            // span
            //   color #ffd200
        &--sp
            border-color #c47fb4
            // span
            //   color #c47fb4
        &--wp
            border-color #22b24c
            // span
            //   color #22b24c
.item-platform--group
  position absolute
  top 0
  left 0
  _flex(column, nowrap, flex-start, center)
  +below(550px)
    left 10px
  .item-platform
    position static
    margin-bottom 8px
// ACTION ICONS
.white-circle
    fill none
    stroke #fff
    stroke-width 2px
    &.dashed
        stroke-dasharray 146px
        transform rotate(-5deg)
        transform-origin center
.view-icon
    fill #fff
    fill-rule evenodd
    /.action:hover &
        fill #08b9e2

.plus, .minus
    transform-origin center
    transform translate3d(0,0,0)
    fill #fff
    fill-rule evenodd
    transition all 0.8s ease-out
    /.action:hover &
        fill #08b9e2


.icon-view
    background url(/img/view-item.svg) no-repeat 0 0
    width 100%
    height 100%
.item-preview
    .label
        width 90%
        text-align left
        margin 0
        // font-size 15px
        color rgba(gray_8, 0.7)
        padding-top 5px
        white-space normal
        span
            line-height 1.2
            display inline-block
            &:first-child
                display block
                // margin-bottom 5px
            &.item-mac
                // font-size 13px
                color #5e5e5e
                //rgba(gray_5, 1)
                display block
            &.item-name
                // font-size 16px
                color gray_8
                font-weight normal
                padding-top 4px
        .item-details
            display block
            // font-size 14px
            line-height 1.1
            color gray_7
            span
                display inline-block
                vertical-align middle
                margin 0
                padding 0
                &.sep
                    margin 0 2px
            /.cart &
                color darken(#fff, 50)
    /.item-small + .label
            font-size 12px
    .item-preview-image
        position relative
        background-position 50% 50%
        background-size auto
        background-repeat no-repeat
        margin 0 auto
        background-color #f9f9f9
        background-blend-mode multiply
        transform translateZ(0)
        +below(600px, orientation: portrait)
          background-size contain
        &:after
          content ''
          position absolute 0 0 0 0
          opacity 0
          background rgba(gray_8, 0.3)
          //background rgba(gray_8, 0.05) url(/img/dark-net.png) repeat 0 0
          z-index 8
          transition opacity 0.7s ease-out-expo
        .media-icon
          white-space nowrap
          text-align center
          opacity 0
          //backface-visibility hidden
          center()
          //transform translate(-50%, -50%) scale(0.5)
          z-index 9
          //font-size responsive 76px 96px
          font-size responsive 12px 16px
          font-weight 500 !important
          color rgba(#fff, 1)
          //transform-style preserve-3d
          will-change opacity, transform
          //transition opacity 0.7s ease-out-expo, transform 0.7s ease-out-expo
          transition opacity 0.7s ease-out-expo
          background-color #159df3
          padding 6px 18px
          border-radius 20px
        /.limited &
          background-size contain
          .media-icon
            display none
          &:after
            display none
            content null
        +desktop()
          &:hover
              &:after
                opacity 0.3
              .media-icon
                opacity 1
                transform translate(-50%, -50%) scale(1)

        /.el-size--large &
          padding-top 230px
        /.el-size--medium &
          padding-top 200px
        /.el-size--small &
            padding-top 180px
          +portrait()
            padding-top 150px !important
        /.el-size--small .q-min &
          padding-top 120px
        /.no-touch &
            box-shadow inset 2px 2px 8px rgba(0,0,0,0.2)
        .item-info
            opacity 0
            transition opacity 0.5s ease-out-circ
            position absolute
            bottom 13%
            left 50%
            transform translateX(-50%)
            .info
                color rgba(#fff, 0.55)
                font-weight 200
                div
                    display inline-block
                    padding 2px 0
                    &[contenteditable="true"]:focus
                        padding 0 4px
                        outline 1px dashed rgba(blue, 0.5)
                        background rgba(#fff, 0.8)
                        color darken(gray, 30)
                &:first-child
                    margin-bottom 3px
        .item-actions
            inline-mid()
            opacity 0
            background rgba(#2e2e2e, 0.9)
            position absolute 0 0 0 0
            transform scale(1.01)
            transition opacity 0.5s ease-out-circ
            border-radius 50%
            text-align center
            pointer-events none
            .action
                position relative
                background transparent
                // border-radius 50%
                margin 0 2.5%
                // border 2px solid #fff
                text-align center
                color #fff
                cursor pointer
                svg
                    max-width 100%
                /.item-big .action
                    fontsizer(18px, 22px)
                    width 22%
                    padding-top 20%
                /.item-huge .action
                    fontsizer(18px, 28px)
                    width 21%
                    padding-top 20%
                /.item-small .action
                    fontsizer(12px, 16px)
                    width 28%
                    padding-top 25%
                span
                    opacity 0
                    position absolute
                    bottom -25px
                    left 50%
                    transform translateX(-50%)
                    text-transform uppercase
                    font-size 12px
                    white-space nowrap
                    +below(550px)
                        display none
                /.active span
                    opacity 1 !important
                &::first-child
                    margin-left 0
                &::last-child
                    margin-right 0
                &:hover
                    i
                        color #03c6f3
                    span
                        opacity 1
        &.active, &:hover
            .item-actions, .item-info
                pointer-events initial
                opacity 1
        &.in-transform
            .plus, .minus
                transform-origin center
                transform-box fill-box
                animation spin 2s infinite cubic-bezier(0.68, -0.55, 0.265, 2)
@keyframes spin
    0%
        transform rotate(0deg)
    100%
        transform rotate(360deg)
</style>
